import slugify from './slugify';

const categoryUrl = category => {
  const url = ['/find'];

  if (category) {
    url.push(`${slugify(category)}`);
    return url.join('/');
  }

  return null;
};

export default categoryUrl;
